
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FaEdit, FaUpload, FaArrowLeft } from "react-icons/fa";
import CreateQuestionModal from "./CreateQuestion";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiDeleteBin5Line } from "react-icons/ri";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";



const QuestionPage = ({ admin }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const classData = location.state?.classData;

  const [questions, setQuestions] = useState([]);
  const [showCreateExamModal, setShowCreateExamModal] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [result, setResult] = useState(null);
  const [showAnswer, setShowAnswer] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const printRef = useRef();

    const [visibleCount, setVisibleCount] = useState(20);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  // Inside your component
  const handleDownloadPDF = () => {
    if (!printRef.current) {
      toast.error("Nothing to print!");
      return;
    }

    html2canvas(printRef.current, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth() - 20; // 10mm margin
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      const pageHeight = pdf.internal.pageSize.getHeight() - 20; // 10mm margin top+bottom
      let position = 10;

      if (pdfHeight <= pageHeight) {
        // fits on one page
        pdf.addImage(imgData, "PNG", 10, position, pdfWidth, pdfHeight);
      } else {
        // content is taller than one page
        let remainingHeight = canvas.height;
        let imgHeight = pdfWidth * canvas.height / canvas.width;
        let pageCanvasHeight = (pageHeight * canvas.width) / pdfWidth;

        let y = 0;

        while (remainingHeight > 0) {
          const canvasPage = document.createElement("canvas");
          canvasPage.width = canvas.width;
          canvasPage.height = Math.min(pageCanvasHeight, remainingHeight);

          const ctx = canvasPage.getContext("2d");
          ctx.drawImage(
            canvas,
            0,
            y,
            canvas.width,
            canvasPage.height,
            0,
            0,
            canvas.width,
            canvasPage.height
          );

          const imgDataPage = canvasPage.toDataURL("image/png");
          pdf.addImage(imgDataPage, "PNG", 10, 10, pdfWidth, (canvasPage.height * pdfWidth) / canvas.width);

          y += canvasPage.height;
          remainingHeight -= canvasPage.height;

          if (remainingHeight > 0) {
            pdf.addPage();
          }
        }
      }

      pdf.save(`${selectedExam.exam_title}_Answer_Key.pdf`);
    });
  };

    const filteredData = questions.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

  const fetchQuestions = async () => {
    try {
      // const res = await axios.get("https://api.scannscore.com/get_exam");
      const res = await axios.get(`https://api.scannscore.com/get_exam/${classData.id}`);

      setQuestions(res.data);
    } catch (err) {
      console.error("Error fetching exams:", err);
      toast.error("Failed to fetch exams", { toastId: "fetch-exams" });
    }
  };



  const fetchResultByExam = async () => {


    try {
      const res = await axios.get(
        `https://api.scannscore.com/fetch-exams-with-result/${classData.id}`

      );
      setResult(res.data);


    } catch (err) {
      toast.error("Failed to fetch exams");
    }
  };

  useEffect(() => {
    fetchQuestions();
    fetchResultByExam();
  }, []);


  
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
  
      // when user reaches bottom (threshold 100px)
      if (scrollTop + windowHeight >= docHeight - 100) {
        loadMore();
      }
    };
  
    window.addEventListener("scroll", handleScroll);
  
    return () => window.removeEventListener("scroll", handleScroll);
  }, [filteredData, visibleCount]);
  
  
  const loadMore = () => {
    if (loadingMore) return;
    if (visibleCount >= filteredData.length) return;
  
    setLoadingMore(true);
  
    setTimeout(() => {
      setVisibleCount((prev) => prev + 20);
      setLoadingMore(false);
    }, 300); 
  };
   useEffect(() => {
    setVisibleCount(20);
  }, [searchTerm]);
  
  
  
  const visibleData = filteredData.slice(0, visibleCount);

  const handleUpload = async (examId, totalQ) => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".xlsx,.xls";

    fileInput.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("exam_id", examId);
      formData.append("total_ques", totalQ);

      try {
        const response = await axios.post(
          "https://api.scannscore.com/upload-bulkexam-excel-data",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (response.status === 200) {
          toast.success("Upload completed successfully", { toastId: `upload-${examId}` });
          fetchQuestions();
        } else {
          toast.error("Upload failed", { toastId: `upload-error-${examId}` });
        }

      } catch (err) {
        console.error("Bulk upload error:", err);
        toast.error(err.response?.data?.message || "Bulk upload failed!", { toastId: `upload-error-${examId}` });
      }
    };

    fileInput.click();
  };

  const handleEdit = (q) => {
    setSelectedExam(q);
    setShowCreateExamModal(true);
  };

  const hasResult = (examId) => {
    return result?.some((item) => item.exam_id === examId);
  };

  const getResultByExam = (examId) => {
    return result?.filter((item) => item.exam_id === examId);
  };

  const handleDelete = async (examId) => {
    const result = await Swal.fire({
      title: "Delete Exam?",
      text: "This will permanently delete the exam and its data. This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`https://api.scannscore.com/delete-exam/${examId}`);

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The exam has been successfully deleted.",
          timer: 1500,
          showConfirmButton: false,
        });

        fetchQuestions();

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete the exam. Please try again.",
        });
      }
    }
  };

 


  return (

    <>


      <div className="container-fluid p-3" style={{ minHeight: "100vh" }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Exams - Class {classData?.class_name}</h2>


          <div className="d-flex flex-column flex-sm-row gap-1 gap-sm-2">

            <button
              className="btn btn-success py-0 px-0 py-sm-2 px-sm-3 d-flex align-items-center justify-content-center gap-1"
              onClick={() => navigate("/admin/student", { state: { classData } })}
            >
              <FaArrowLeft /> Back
            </button>

            {(admin.role == "admin" || admin.exam == 1) && (
              <button
                className="btn btn-primary py-0 px-2 py-sm-2 px-sm-3"
                onClick={() => {
                  setSelectedExam(null);
                  setShowCreateExamModal(true);
                }}
              >
                Create Exam
              </button>
            )}

          </div>

          
        </div>

           <div className="col-12 col-md-4 mb-3">
                            <input
                                type="text"
                                className="form-control border-info "
                                placeholder="Search by exam title..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

        {visibleData.length === 0 ? (
          <div className="text-center text-muted mt-5">No exams found.</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped table-hover text-center align-middle">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Exam Title</th>
                  <th>Status</th>
                  <th>Total Questions</th>
                  <th>Options</th>
                  <th>Correct</th>
                  <th>Wrong</th>
                  <th>Penalty</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {visibleData.map((q) => (
                  <tr key={q.id}>
                    <td>{q.id}</td>
                    <td>{q.exam_title}</td>
                    <td>{q.status}</td>
                    <td>{q.total_questions}</td>
                    <td>{q.option_count}</td>
                    <td>{q.correct_marks}</td>
                    <td>{q.wrong_marks}</td>
                    <td>{q.penalty}</td>


                    <td className="d-flex justify-content-center gap-2">


                      {(admin.role === 'admin' || admin.exam == 1) ? (

                        hasResult(q.id) ? (


                          <button
                            className="btn btn-sm btn-success"
                            onClick={() =>
                              navigate('/admin/exam-result', {
                                state: {
                                  exam: q,
                                  result: getResultByExam(q.id)
                                }
                              })
                            }
                          >
                            View Result
                          </button>
                        ) : (

                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() => handleEdit(q)}
                          >
                            <FaEdit />
                          </button>
                        )

                      ) : "-"}

                      {/* Upload button (only if no result AND no questions) */}
                      {(admin.role === "admin" || admin.exam === 1) &&
                        q.is_ques != "Yes" &&
                        !hasResult(q.id) && (
                          <button
                            className="btn btn-sm btn-info text-white d-flex align-items-center gap-1"
                            onClick={() => handleUpload(q.id, q.total_questions)}
                          >
                            <FaUpload />
                          </button>
                        )}

                      {q.is_ques == 'Yes' &&
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => {
                            setShowAnswer(true);
                            setSelectedExam(q)
                          }
                          }
                        >
                          Answer Key
                        </button>}

                      {(admin.role === "admin" || admin.exam === 1) &&
                        q.is_ques != "Yes" &&
                        !hasResult(q.id) && (
                          <button
                            className="btn btn-sm btn-danger text-white d-flex align-items-center gap-1"
                            onClick={() => handleDelete(q.id)}
                          >
                            <RiDeleteBin5Line />
                          </button>
                        )}

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}


        {showAnswer && (
          <Modal
            show={showAnswer}
            onHide={() => setShowAnswer(false)}
            size="lg"
            centered
          >
            <div ref={printRef} className="print-area">
              <Modal.Header closeButton className="px-3">
                <h6 className="">{selectedExam.exam_title} Answer Key</h6>
              </Modal.Header>

              <Modal.Body>

                <div className="table-responsive p-0">
                  <table className="table text-center m-0">
                    <thead>
                      <tr>
                        <th>Q</th>
                        <th>Option</th>
                        <th>Correct</th>
                        <th>Incorrect</th>
                      </tr>
                    </thead>

                    <tbody>
                      {(typeof selectedExam.questions === "string"
                        ? JSON.parse(selectedExam.questions)
                        : selectedExam.questions || []
                      ).map((qNo) => {

                        return (
                          <tr key={qNo}>
                            <td>{qNo.question_no}</td>
                            <td>{qNo.answer}</td>
                            <td>{qNo.correct_marks}</td>
                            <td>{qNo.wrong_marks}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

              </Modal.Body>

            </div>
            <button
              className="btn btn-success mx-3 mb-3"
              onClick={handleDownloadPDF}
            >
              Download PDF
            </button>

          </Modal>
        )}

        {showCreateExamModal && (
          <CreateQuestionModal
            examData={selectedExam}
            classData={classData}
            admin={admin}
            onClose={() => {
              setShowCreateExamModal(false);
              setSelectedExam(null);
            }}
            refreshQuestions={fetchQuestions}
          />
        )}

        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          theme="colored"
        />
      </div>
    </>
  );
};

export default QuestionPage;

